"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _functions = require("@jobmatchme/ui/es/utils/functions");

var _External = require("@jobmatchme/routing/es/provider/External");

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _reactI18next = require("react-i18next");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var LoginHeaderButtons = function LoginHeaderButtons(_ref) {
  var discriminator = _ref.discriminator,
      _ref$withLogin = _ref.withLogin,
      withLogin = _ref$withLogin === void 0 ? true : _ref$withLogin;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var locale = (0, _functions.getLocale)();
  var routes = (0, _External.useApplicationRoutes)();

  var setLocalStorageForGA = function setLocalStorageForGA(name) {
    try {
      if (!localStorage.getItem(name)) {
        localStorage.setItem(name, true);
      }
    } catch (error) {
      return console.error('Error: ', error);
    }
  };

  var gotoPath = function gotoPath(target, locale) {
    var url = routes[target]; // we need this data for further analysis in GTAG

    setLocalStorageForGA('target_' + target);

    if (target === 'bcPage') {
      // Temporary path with UTM Params for Hubspot Pages
      if (window && locale === 'de') {
        var urlParams = window.location.search;
        var utms = urlParams === undefined || urlParams === '' ? '' : urlParams;
        window.location = "https://pages.jobmatch.me/de-de/arbeitgeber".concat(utms);
      } else if (window && locale === 'pl') {
        window.open('https://jobmatch.me/pl/pracodawca/', '_self');
      }
    } else {
      window.open(url, '_self');
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    className: _styleModule.default.btnWrapper,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: _styleModule.default.buttons,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        flat: true,
        round: true,
        size: "small",
        color: "dark",
        variant: "outlined",
        texttransform: "none",
        onClick: function onClick() {
          return gotoPath('bcPage', locale);
        },
        children: t('ui.LoginHeaderButtons.bcButton')
      }), "\xA0\xA0", withLogin && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        flat: true,
        round: true,
        size: "small",
        color: discriminator === 'care' ? 'primary' : discriminator === 'service-gastro' ? 'dark' : 'secondary',
        variant: "outlined",
        texttransform: "none",
        onClick: function onClick() {
          return gotoPath('pcLogin', locale);
        },
        children: t('ui.LoginHeaderButtons.pcLoginButton')
      })]
    })
  });
};

var _default = /*#__PURE__*/_react.default.memo(LoginHeaderButtons);

exports.default = _default;